module.exports = __webpack_public_path__ + "img/Rectangle 10118.93c1295c.svg";